/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

 
// (function() {

//   // Below are example event listeners.  They listen for theme events that Pipeline
//   // fires in order to make it easier for you to add customizations.

//   // Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.

 
//   document.addEventListener('theme:variant:change', function(event) {
//     // You might use something like this to write a pre-order feature or a
//     // custom swatch feature.
//     var variant = event.detail.variant;
//     var container = event.target;
//     if (variant) {
//       console.log('Container ———————— ↓');
//       console.log(container);
//       console.log('Variant —————————— ↓');
//       console.log(variant);
//       // ... update some element on the page
//     }
//   });

//   document.addEventListener('theme:cart:change', function(event) {
//     var cart = event.detail.cart;
//     if (cart) {
//       console.log('Cart ———————————— ↓');
//       console.log(cart);
//       // ... update an app or a custom shipping caluclator
//     }
//   });
//   // Fired when page loads to update header values
//   document.addEventListener('theme:cart:init', (e) => {
//     console.log('theme:cart:init');
//     console.log(e);
//   });

//   // Debounced scroll listeners.  Up and down only fire on direction changes
//   // These events are useful for creating sticky elements and popups.
//   document.addEventListener('theme:scroll', e => { console.log(e); });
//   document.addEventListener('theme:scroll:up', e => { console.log(e); });
//   document.addEventListener('theme:scroll:down', e => { console.log(e); });

//   // Debounced resize listener to bundle changes that trigger document reflow
//   document.addEventListener('theme:resize', e => { console.log(e); });

//   // Locks and unlocks page scroll for modals and drawers
//   // These are commented out because firing them will lock the page scroll
//   // the lock event must set `detail` to the modal or drawer body so the 
//   // scroll locking code knows what element should maintain scoll. 
//   // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
//   // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


//   // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.
// })();
 
 

function ajaxAddToCart(dynamicData, currentThis) {   

  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: {items:dynamicData},
    dataType: "json",
    success: function(data){ 
     $(currentThis).next('.btn--add-to-cart').click();   
      // $('.navlink--cart').trigger('click');
      $('.product__submit .overlay_btn').removeClass('disabled');
    },
    error: function(jqXHR, textStatus, errorThrown) {
      $('#cdk-BuyProductGroup').text('Add To Cart');
      if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
      if(jqXHR.status == 422) { alert(jqXHR.responseJSON.description); }
    }
  });
}

$(document).on('click', 'product-add-button .overlay_btn', function () {
  //console.log('click');
  $(this).addClass('disabled');
  const thisVarID = $(this).attr('data-var');
  //console.log('thisVarID::' + thisVarID);
  const nowTimestamp = new Date().getTime();
  $('.timestamp').val(nowTimestamp);
  const isChecked = $('.ptw-gift-needed1').prop('checked');

  let variantId;
  if (!thisVarID) {
    $(this).next('.btn--add-to-cart').click();
    return; // Exit if no variant ID
  } else {
    variantId = isChecked ? $('.ptw-gift-needed1').attr('data-var') : thisVarID;
  }

  const items = [{
    quantity: 1,
    id: variantId,
    properties: { _timestamp: nowTimestamp }
  }];

  ajaxAddToCart(items, $(this));
});

 
  function updateCartWithItems(cartData) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js', // Shopify's cart update endpoint
      data: {
        updates: cartData,
      },
      dataType: 'json',
      success: function (cart) {
        // console.log('Cart updated successfully:', cart);
        // UpdateCartDrawer();
        cartCount();
        // Do something after the cart is updated, like refreshing the cart view.
      },
      error: function (xhr, textStatus, errorThrown) {
        console.error('Error updating cart:', errorThrown);
        // Handle the error, if any.
      },
    });
  }
  function updateCartPageWithItems(cartData) {
    $.ajax({
      type: 'POST',
      url: '/cart.js', // Shopify's cart update endpoint
      data: {
        updates: cartData,
      },
      dataType: 'html',
      success: function (cart) {
        
        // UpdateCartPage();
        cartCount();
       let cartItems = $(cart).find('.cart__template .cart__items').html();
        let cartFooter = $(cart).find('.cart__template .template__cart__footer').html();
        // console.log('Cart updated successfully:', cartItems);
        $('.cart__template .cart__items').html(cartItems);
        $('.cart__template .template__cart__footer').html(cartFooter);
        $('.cart__template').find('[data-cart-loading]').removeClass('cart--loading');
        // Do something after the cart is updated, like refreshing the cart view.
      },
      error: function (xhr, textStatus, errorThrown) {
        console.error('Error updating cart:', errorThrown);
        // Handle the error, if any.
      },
    });
  }
  function cartCount() {
    $.getJSON("/cart.js", function (cart) {
      var itemCount = cart.item_count;
            var totalm = 0;	
            $('[data-qtyminus]').each(function(){	
              var qty = $(this).attr('data-qtyminus')	
              // console.log('qty', qty)	
              totalm = totalm + parseInt(qty);	
            })	
            //console.log('total-minus', totalm)	
            count =  itemCount - totalm;
            // console.log('cartdata::'+ count);
            // $('.header__cart__status span').attr('data-header-cart-count', count);
      if (count > 0){
            $(".header__cart__status span[data-header-cart-count]").attr("data-header-cart-count",count);
          }
          else{
            $(".header__cart__status span[data-header-cart-count]").attr("data-header-cart-count",'0');
          }
        if (itemCount <= 0){
          $('.cart__template .cart__empty__page').removeClass('cart--hidden');
          $('.cart__template [data-cart-loading]').addClass('cart--hidden');
        }
      else{
        $('.cart__template .cart__empty__page').addClass('cart--hidden');
        $('.cart__template [data-cart-loading]').removeClass('cart--hidden');
      }
        // $("body").addClass("overflow-hidden");
    });
  }


function UpdateCartDrawer(){ 
  $.ajax({
    url: '/',
    type: 'GET',
    dataType: 'html',
    beforeSend: function() {
      // console.log('testing.....');
    }
  })
  .done(function(data) {
    // Append data 
    // console.log('testing..........'+$(data).find('#CartDrawerForm').html());
  
    $('#drawer-cart').html($(data).find('#drawer-cart').html()); 
  });

}
function UpdateCartPage() { 
  $.ajax({
    url: '/cart.js',
    type: 'GET',
    dataType: 'html',
    beforeSend: function() {
      //console.log('Fetching cart data...');
      $('#loading-indicator').show(); // Show loading indicator
    }
  })
  .done(function(data) {
    //console.log('Cart data fetched:', data);
    // $('#drawer-cart').html($(data).find('#drawer-cart').html()); // Update cart display
  })
  .fail(function(xhr, textStatus, errorThrown) {
    console.error('Error fetching cart:', errorThrown);
    alert('Failed to update cart view. Please try again.'); // User feedback
  })
  .always(function() {
    $('#loading-indicator').hide(); // Hide loading indicator after completion
  });
}

$(document).ready(function () {

   $(document).on('click', 'product-add-button .overlay_btn', function () {
    console.log('click');
    $(this).addClass('disabled');
    const thisVarID = $(this).attr('data-var');
    console.log('thisVarID::' + thisVarID);
    const nowTimestamp = new Date().getTime();
    $('.timestamp').val(nowTimestamp);
    const isChecked = $('.ptw-gift-needed1').prop('checked');
  
    let variantId;
    if (!thisVarID) {
      $(this).next('.btn--add-to-cart').click();
      return; // Exit if no variant ID
    } else {
      variantId = isChecked ? $('.ptw-gift-needed1').attr('data-var') : thisVarID;
    }
  
    const items = [{
      quantity: 1,
      id: variantId,
      properties: { _timestamp: nowTimestamp }
    }];
  
    ajaxAddToCart(items, $(this));
  });
  
  // Quantity plus

  $(document).on('click', '.cart__drawer .cart__items__row .cart__items__remove', function (evt) {
    evt.preventDefault(); 
    var updatedCartData = {};
     var qtySelector = $(this).parents('.cart__items__row').find('input');
     var thisGroupId = qtySelector.attr('data-groupid');
    // console.log('thisGroupId::'+thisGroupId);
    var qtyUnit = 0;
    //console.log('qtyUnit::'+qtyUnit);
    var newQuantity = 0;
    //console.log('newQuantity::'+newQuantity);
    $(qtySelector).val(newQuantity);
    $('#drawer-cart .drawer__body').addClass('loading');
    // $(this).parents('.cart__items__row').find('.item--loadbar').show();
    $('.cart__drawer .cart__items__row').each(function () {
      var eachGroupId = $(this).find('.cart__items__quantity').find('input.quantity__input').attr('data-groupid');
      if (eachGroupId == thisGroupId) {
        var thisVarId = $(this).find('.cart__items__quantity').find('input.quantity__input').attr('data-update-cart');
        updatedCartData[thisVarId] = newQuantity;
      }
    });
    setTimeout (function(){
      updateCartWithItems(updatedCartData); 
    },2000)
     
  })
  
  $(document).on('click', '.cart__drawer .cart__items__quantity .quantity__button--plus', function () {
    var updatedCartData = {};
     var qtySelector = $(this).parents('.cart__items__quantity').find('input');
     var thisGroupId = qtySelector.attr('data-groupid'); 
    var qtyUnit = parseInt(qtySelector.val()); 
    var newQuantity = qtyUnit + 1; 
    $(qtySelector).val(newQuantity);
    $('#drawer-cart .drawer__body').addClass('loading');
    $('.cart__drawer .cart__items__row').each(function () {
      var eachGroupId = $(this).find('.cart__items__quantity').find('input.quantity__input').attr('data-groupid');
      if (eachGroupId == thisGroupId) {
        var thisVarId = $(this).find('.cart__items__quantity').find('input.quantity__input').attr('data-update-cart');
        updatedCartData[thisVarId] = newQuantity;
      }
    }); 
     updateCartWithItems(updatedCartData); 
  })

    // Quantity minus

    $(document).on('click', '.cart__drawer .cart__items__quantity .quantity__button--minus', function () {
    var updatedCartData = {};
    
     var qtySelector = $(this).parents('.cart__items__quantity').find('input');
     var thisGroupId = qtySelector.attr('data-groupid');
    //console.log('thisGroupId::'+thisGroupId);
    // Get the current quantity value
    var qtyUnit = parseInt(qtySelector.val());
    //console.log('qtyUnit::'+qtyUnit);
     // Increment the quantity value
      if(qtyUnit > 0){
        var newQuantity = qtyUnit - 1;    
      }else{
        var newQuantity = qtyUnit;
      }
    
     //console.log('newQuantity::'+newQuantity);
    // Update the input field with the new quantity
    $(qtySelector).val(newQuantity);
 
    $('#drawer-cart .drawer__body').addClass('loading');

        // Loop through each cart item and build the updatedCartData object
    $('.cart__drawer .cart__items__row').each(function () {
      var eachGroupId = $(this).find('.cart__items__quantity').find('input.quantity__input').attr('data-groupid');
      if (eachGroupId == thisGroupId) {
        var thisVarId = $(this).find('.cart__items__quantity').find('input.quantity__input').attr('data-update-cart');
        
        updatedCartData[thisVarId] = newQuantity;
      }
    }); 
     updateCartWithItems(updatedCartData); 
  })

 
  
  $(document).on('click', '.cart__drawer .drawer__button.drawer__close', function (evs) {
    evs.preventDefault(); 
    $('html').removeAttr('data-scroll-locked');
    $('body').css('overflow','visible');
    $('#drawer-cart').removeClass('drawer--visible');
    setTimeout(function () {
       $('#drawer-cart').addClass('display-none');
    },300)
  })

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) { 
       // UpdateCartDrawer();
    }
  });
 // cart page remove
$(document).on('click', '.cart__template .cart__items__row .cart__items__remove', function (evt) {
    evt.preventDefault();
    $(this).parents('[data-cart-loading]').addClass('cart--loading');
    var updatedCartData = {};
     var qtySelector = $(this).parents('.cart__items__row').find('input');
     var thisGroupId = qtySelector.attr('data-groupid');
 
    var qtyUnit = 0;
    //console.log('qtyUnit::'+qtyUnit);
    var newQuantity = 0;
     //console.log('newQuantity::'+newQuantity);
    $(qtySelector).val(newQuantity);
   
    $(this).parents('.cart__items__row').find('.item--loadbar').show();
    $('.cart__template .cart__items__row').each(function () {
      var eachGroupId = $(this).find('.cart__items__quantity').find('input.quantity__input').attr('data-groupid');
      if (eachGroupId == thisGroupId) {
        var thisVarId = $(this).find('.cart__items__quantity').find('input.quantity__input').attr('data-update-cart');
        updatedCartData[thisVarId] = newQuantity;
      }
    });
      updateCartPageWithItems(updatedCartData); 
     
  })
  $(document).on('change', '.cart__template .cart__items__quantity .quantity__input', function () {
    var updatedCartData = {};
     var thisGroupId = $(this).attr('data-groupid');
    //console.log('thisGroupId::'+thisGroupId);
    var qtyUnit = parseInt($(this).val());
    //console.log('qtyUnit::'+qtyUnit);
 
    $(this).parents('.cart__items__row').find('.item--loadbar').show();
    $('.cart__template .cart__items__row').each(function () {
      var eachGroupId = $(this).find('.cart__items__quantity').find('input.quantity__input').attr('data-groupid');
      if (eachGroupId == thisGroupId) {
        var thisVarId = $(this).find('.cart__items__quantity').find('input.quantity__input').attr('data-update-cart');
        updatedCartData[thisVarId] = qtyUnit;
      }
    }); 
       updateCartPageWithItems(updatedCartData); 
})
  
  $(document).on('click', '#ptw-wrapin-pr .ptw-app-wrapper .cnter_content .learnMoreAbout', function(){
    $('.popup_gift_box_overlay, .popup_gift_box').fadeIn(100);
  });

  $(document).on('click', '.popup_gift_box .popup_container .popup_close_btn, .popup_gift_box_overlay', function(){
    $('.popup_gift_box_overlay, .popup_gift_box').fadeOut(100);
  });
  $(document).on('click', '.drawer .switch input + .slider.round', function(){
    $(this).prop("checked", true);
    $(this).toggleClass('active');
  });

// Product Page
  
  // on variant change image update order update
  
  $('.current_variant_input').on('change', function() {
    var current_variant_input = $('.current_variant_input').val();
    var variantImage = $('.master-product_variants option[value="'+current_variant_input+'"]').attr('data-image');
    var regularPrice = $('.master-product_variants option[value="'+current_variant_input+'"]').attr('reg-price');
    var regularPriceCheck = parseInt(regularPrice.replace(/[^0-9.-]+/g, ''), 10); 
    var comparePrice = $('.master-product_variants option[value="'+current_variant_input+'"]').attr('comp-price');
    var percentage = $('.master-product_variants option[value="'+current_variant_input+'"]').attr('var-off-percent');
    var comparePriceCheck = parseInt(comparePrice.replace(/[^0-9.-]+/g, ''), 10); 
    var percentage = parseInt(percentage);
    var variantId = $('.master-product_variants option[value="'+current_variant_input+'"]').attr('data-variant-id');
     
    // console.log('comparePrice::'+comparePrice); 
    //  console.log('comparePriceCheck::'+comparePriceCheck);

    if(comparePriceCheck && comparePriceCheck > regularPriceCheck){
      $('[data-product-compare-price]').text(comparePrice);
      $('[data-product-compare-price]').attr('data-variant-id',variantId);
      $('[data-product-price]').addClass('product__price--sale');
      $('[data-product-price]').attr('data-variant-id',variantId);
      $('.cdkStickyPrice .price__sale').text(comparePrice);
      $('.cdkStickyPrice .price__sale').attr('data-variant-id',variantId);
    }else{
      $('[data-product-compare-price]').text("");
      $('[data-product-compare-price]').attr('data-variant-id',variantId);
      $('[data-product-price]').removeClass('product__price--sale');
      $('[data-product-price]').attr('data-variant-id',variantId);
      $('.cdkStickyPrice .price__sale').text();
      $('.cdkStickyPrice .price__sale').attr('data-variant-id',variantId);
    }

    if(percentage > 0){
      $('[cdk-price-off-amount]').text(percentage);
      $('.product__media__wrapper .product__price--off.image_block_sales').show();
    }else{
      $('.product__media__wrapper .product__price--off.image_block_sales').hide();
    }
     
    if (variantImage) {
        $('.product__media__wrapper .product__grid.product__grid--mosaic .product__media').removeClass('starting-slide');
        $('.product__media__wrapper .product__grid.product__grid--mosaic .product__media').addClass('secondary-slide');
        $('.product__media__wrapper .product__grid.product__grid--mosaic .product__media[data-media-src-placeholder*="' + variantImage + '"]').addClass('starting-slide');
        $('.product__media__wrapper .product__grid.product__grid--mosaic .product__media[data-media-src-placeholder*="' + variantImage + '"]').removeClass('secondary-slide');
    }
});

  // on variant change material and plating update

  $(document).on('click', '.product__block__variants .swatch__button input', function() {
    var variantMaterial = $(this).attr('variant__material');
    var variantPlating = $(this).attr('variant__plating');
    var preOrderType = $(this).attr('data-pre-order');
    var available = $(this).attr('available');
    var $materialText = $(this).parents('.product__block__variants').find('.variant__about .variant_material .material_text');
    var $platingText = $(this).parents('.product__block__variants').find('.variant__about .variant_plating .plating_text');
    //console.log('preOrderType::'+preOrderType+ 'available::'+ available);
    if (variantMaterial) {
      $materialText.find('.material_value').text(variantMaterial);
      $materialText.show();
    } else {
      $materialText.hide();
    }
  
    if (variantPlating) {
      $platingText.find('.plating_value').text(variantPlating);
      $platingText.show();
    } else {
      $platingText.hide();
    }
    if (preOrderType) {
      $('#preorder_input_hidden').html('<input type="hidden" name="properties[Order Type]" value="Pre Order">');
      $('.cdk_preorder_text').show();
        $('.pre-order').show();
        $('.add-to-cart-main').hide();
    } else {
      $('.cdk_preorder_text').hide();
      $('#preorder_input_hidden').html('');
        $('.add-to-cart-main').show();
        $('.pre-order').hide();
    }
  });


  //  $(document).on('click', '.btn--add-to-cart', function() {
  //     $( document ).one( "ajaxComplete", function( event, xhr, settings ) {
  //        console.log("check Url: " + settings.url);
  //       if ( settings.url === "/cart/add.js" ) {
  //         setTimeout(function () {
  //           $('.cart__drawer').removeClass('display-none');
  //           // $('.cart__drawer').addClass('drawer--visible');
  //           $('html').attr('data-scroll-locked','');
  //           cartCount();
  //         },5000)
  //       }
  //     }); 
  // });
  
})


// Bundle Code Start

function ajaxAddToCartBogo(dynamicData) {   

  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: {items:dynamicData},
    dataType: "json",
    success: function(data){ 
      $('#cdk-BuyProductGroup').text('Add To Cart');
      window.location.href = "/cart";
    },
    error: function(jqXHR, textStatus, errorThrown) {
      $('#cdk-BuyProductGroup').text('Add To Cart');
      if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
      if(jqXHR.status == 422) { alert(jqXHR.responseJSON.description); }
    }
  });
}

  function ajaxAddToCartBogobundle(dynamicData) {   
  
    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: {items:dynamicData},
      dataType: "json",
      success: function(data){ 
        //$('#cdk-BuyProductGroup').text('Add To Cart');
        window.location.href = "/checkout?discount=BOGOBUNDLE";
      },
      error: function(jqXHR, textStatus, errorThrown) {
        //$('#cdk-BuyProductGroup').text('Add To Cart');
        if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
        if(jqXHR.status == 422) { alert(jqXHR.responseJSON.description); }
      }
    });
  }
$(document).ready(function(){ 
  $(".mobile-logo-close .header__toggle__icon").click(function(){
    $(this).toggleClass("open");
    $(".mobile-toggle-menu").slideToggle("milliseconds");
  });

  $(document).on('click','.lp_bundle_product_item .lp_bundle_detail .bundle_addbtn', function(){
    var thisId = $(this).parents('.lp_bundle_product_item').attr('var-id');
    var totalComparePrice = parseInt($('.bundle_checkout_box .bundle_price_block .bundle_compare_price').attr('data-total'));
    var totalRegularPrice = parseInt($('.bundle_checkout_box .bundle_price_block .bundle_regular_price').attr('data-total'));
    var thisComparePrice = parseInt($(this).parents('.lp_bundle_product_item').find('.item_compare_price').attr('data-price'));
    var thisRegularPrice = parseInt($(this).parents('.lp_bundle_product_item').find('.item_Price_price').attr('data-price'));
    
    var UptotalComparePrice = totalComparePrice + thisComparePrice;
    var UptotalRegularPrice = totalRegularPrice + thisRegularPrice;
    
    var thisImage = $(this).parents('.lp_bundle_product_item').find('.bundle_prod_image').attr('src');
    var thistitle = $(this).parents('.lp_bundle_product_item').find('.lp_bundle_prod_title').text();
    var thisVal = $(this).parents('.lp_bundle_product_item').find('input').val();
    var thisVal = parseInt(thisVal);
    var thisIncrement = parseInt(thisVal + 1);

    $('.bundle_checkout_box .bundle_price_block .bundle_compare_price').attr('data-total', UptotalComparePrice).text('$ '+UptotalComparePrice);
    $('.bundle_checkout_box .bundle_price_block .bundle_regular_price').attr('data-total', UptotalRegularPrice).text('$ '+UptotalRegularPrice);
    // console.log('thisId::'+thisId);
    // console.log('thisImage::'+thisImage);
    // console.log('thistitle::'+thistitle);
    // console.log('thisIncrement::'+thisIncrement);
    $('.bundle-item-wrapper .selected-items').append(' <li data-list-id="'+thisId+'-'+thisIncrement+'"><div class="product" bis_skin_checked="1"><img src="'+thisImage+'"></div><div class="title">"'+thistitle+'"</div><button data-id="'+thisId+'" class="remove-item">x</button></li> ');
    $(this).next('.bty_btn_flex').addClass('selected');
    $(this).parents('.lp_bundle_product_item').find('input').val(thisVal + 1);
    $(this).parents('.lp_bundle_product_item').addClass('selected').attr('data-quantity', thisVal + 1);
    $('.bundle_checkout_box .bundle_price_block .bundle_compare_price').attr('data-total');
    $('.bundle_checkout_box .bundle_price_block .bundle_regular_price').attr('data-total');
    
    var LengthOfItem = $('.bundle_checkout_products .bundle-item-wrapper ul.selected-items li').length;
    var LengthOfItemInc = LengthOfItem +1 ; 
   
    // console.log('thisComparePrice::'+thisComparePrice);
    // console.log('thisRegularPrice::'+thisRegularPrice);
    // console.log('totalComparePrice::'+totalComparePrice);
    // console.log('totalRegularPrice::'+totalRegularPrice);

    console.log('LengthOfItem::'+LengthOfItem);
    if(LengthOfItem >= 3){
      $('.lp-bundle_checkout .bundle-atc').addClass('active'); 
    }
    if(LengthOfItem > 3){
     $('.bundle-item-wrapper .items').append('<li data-index="'+LengthOfItemInc+'"> <div class="product" bis_skin_checked="1">'+LengthOfItemInc+'</div> <div class="title" bis_skin_checked="1">Item '+LengthOfItemInc+'</div> </li>'); 
    } 
  })

  $(document).on('click','.lp_bundle_product_item .lp_bundle_detail .input_btn.plus', function(){
    var thisId = $(this).parents('.lp_bundle_product_item').attr('var-id');
    
    var totalComparePrice = parseInt($('.bundle_checkout_box .bundle_price_block .bundle_compare_price').attr('data-total'));
    var totalRegularPrice = parseInt($('.bundle_checkout_box .bundle_price_block .bundle_regular_price').attr('data-total'));
    var thisComparePrice = parseInt($(this).parents('.lp_bundle_product_item').find('.item_compare_price').attr('data-price'));
    var thisRegularPrice = parseInt($(this).parents('.lp_bundle_product_item').find('.item_Price_price').attr('data-price'));
    
    var UptotalComparePrice = totalComparePrice + thisComparePrice;
    var UptotalRegularPrice = totalRegularPrice + thisRegularPrice;
    
    var thisImage = $(this).parents('.lp_bundle_product_item').find('.bundle_prod_image').attr('src');
    var thistitle = $(this).parents('.lp_bundle_product_item').find('.lp_bundle_prod_title').text();
    var thisVal = $(this).parents('.lp_bundle_product_item').find('input').val();
    var thisVal = parseInt(thisVal);
    var thisIncrement = parseInt(thisVal + 1);

    $('.bundle_checkout_box .bundle_price_block .bundle_compare_price').attr('data-total', UptotalComparePrice).text('$ '+UptotalComparePrice);
    $('.bundle_checkout_box .bundle_price_block .bundle_regular_price').attr('data-total', UptotalRegularPrice).text('$ '+UptotalRegularPrice);
    
    // console.log('thisComparePrice::'+thisComparePrice);
    // console.log('thisRegularPrice::'+thisRegularPrice);
    // console.log('totalComparePrice::'+totalComparePrice);
    // console.log('totalRegularPrice::'+totalRegularPrice);
    
    $('.bundle-item-wrapper .selected-items').append(' <li data-list-id="'+thisId+'-'+thisIncrement+'"><div class="product" bis_skin_checked="1"><img src="'+thisImage+'"></div><div class="title">"'+thistitle+'"</div><span data-id="'+thisId+'" class="remove-item">x</span></li> ');
    $(this).next('.bty_btn_flex').addClass('selected');
    $(this).parents('.lp_bundle_product_item').find('input').val(thisVal + 1);
    $(this).parents('.lp_bundle_product_item').addClass('selected').attr('data-quantity', thisVal + 1);
    var LengthOfItem = $('.bundle_checkout_products .bundle-item-wrapper ul.selected-items li').length;
     var LengthOfItemInc = LengthOfItem +1 ; 
    //console.log('LengthOfItem::'+LengthOfItem);
    if(LengthOfItem >= 3){
      $('.lp-bundle_checkout .bundle-atc').addClass('active'); 
    }
    if(LengthOfItem > 3){
     $('.bundle-item-wrapper .items').append('<li data-index="'+LengthOfItemInc+'"> <div class="product" bis_skin_checked="1">'+LengthOfItemInc+'</div> <div class="title" bis_skin_checked="1">Item '+LengthOfItemInc+'</div> </li>'); 
    } 
  })

  $(document).on('click', '.lp_bundle_product_item .lp_bundle_detail .input_btn.minus', function() {
    var thisId = $(this).parents('.lp_bundle_product_item').attr('var-id');
    var thisVal = $(this).parents('.lp_bundle_product_item').find('input').val();
    var thisVal = parseInt(thisVal);
  
    var totalComparePrice = 0;
    var totalRegularPrice = 0;
  
    // Recalculate total prices based on remaining items and their quantities
    $('.lp_bundle_container .lp_bundle_row').find('.lp_bundle_product_item.selected').each(function() {
      var variantId = $(this).attr('var-id');
      var quantity = parseInt($(this).attr('data-quantity'));
      var thisComparePrice = parseInt($(this).find('.item_compare_price').attr('data-price'));
      var thisRegularPrice = parseInt($(this).find('.item_Price_price').attr('data-price'));
  
      if (variantId !== thisId) {
        totalComparePrice += thisComparePrice * quantity;
        totalRegularPrice += thisRegularPrice * quantity;
      } else if (quantity > 1) {
        totalComparePrice += thisComparePrice * (quantity - 1);
        totalRegularPrice += thisRegularPrice * (quantity - 1);
      }
    });
  
    $('.bundle_checkout_box .bundle_price_block .bundle_compare_price').attr('data-total', totalComparePrice).text('$ ' + totalComparePrice);
    $('.bundle_checkout_box .bundle_price_block .bundle_regular_price').attr('data-total', totalRegularPrice).text('$ ' + totalRegularPrice);
  
    var LengthOfItem = $('.bundle_checkout_products .bundle-item-wrapper ul.selected-items li').length;
  
    if (!isNaN(thisVal) && thisVal > 1) {
      $('.bundle-item-wrapper .selected-items li[data-list-id="' + thisId + '-' + thisVal + '"]').remove();
      $(this).parents('.lp_bundle_product_item').find('input').val(thisVal - 1);
      $(this).parents('.lp_bundle_product_item').addClass('selected').attr('data-quantity', thisVal - 1);
    } else if (!isNaN(thisVal) && thisVal == 1) {
      $('.bundle-item-wrapper .selected-items li[data-list-id="' + thisId + '-' + thisVal + '"]').remove();
      $(this).parents('.lp_bundle_product_item').find('input').val(thisVal - 1);
      $(this).parents('.lp_bundle_product_item').removeClass('selected').attr('data-quantity', 0);
    }
  
    var remainingItems = $('.bundle_checkout_products .bundle-item-wrapper ul.selected-items li').length;
    if (remainingItems < 3) {
      $('.lp-bundle_checkout .bundle-atc').removeClass('active');
    } else {
      $('.lp-bundle_checkout .bundle-atc').addClass('active');
    }
  
    // Remove items from .bundle-item-wrapper .items li after index 3
    $('.bundle-item-wrapper .items li:gt(2)').remove();
  
    // Add new items to .bundle-item-wrapper .items li if needed
    if (remainingItems > 3) {
      var currentItemCount = $('.bundle-item-wrapper .items li').length;
      for (var i = currentItemCount + 1; i <= remainingItems; i++) {
        $('.bundle-item-wrapper .items').append('<li data-index="' + i + '"> <div class="product" bis_skin_checked="1">' + i + '</div> <div class="title" bis_skin_checked="1">Item ' + i + '</div> </li>');
      }
    }
  })

  $(document).on('click','.bundle_checkout_products .bundle-item-wrapper ul.selected-items li .remove-item', function(){
    var thisId = $(this).attr('data-id');
    $('.lp_bundle_container .lp_bundle_row .lp_bundle_product_item[var-id="'+thisId+'"]').find('.input_btn.minus').click();
  })
  
  $(document).on('click' ,'#cdk-BuyProductGroup',function(){
    $(this).text('Please wait...')
    var items = []; 
    $('.lp_bundle_container .lp_bundle_row').find('.lp_bundle_product_item.selected').each(function(){
      var variantId = $(this).attr('var-id'), quantity = $(this).attr('data-quantity');
      if(quantity > 0){items.push({ quantity: quantity,  id: variantId});}
    })
    ajaxAddToCartBogo(items) ;
  });

  $(document).on('click' ,'#cdk-BuyProductBogo',function(){
    $(this).text('מפעיל את ההנחה...')
    var items = []; 
    $('.lp_bundle_container .lp_bundle_row').find('.lp_bundle_product_item.selected').each(function(){
      var variantId = $(this).attr('var-id'), quantity = $(this).attr('data-quantity');
      if(quantity > 0){items.push({ quantity: quantity,  id: variantId});}
    })
    ajaxAddToCartBogo(items) ;
  });

  var $flicketyCarousel = $('.bundle_popup_slider_container .bundle_popup_slider').flickity();
  $flicketyCarousel.flickity();
  
  $(document).on('click','.bundle_images_zoom_popup .zoom_image_container .close_btn, .bundle_images_zoom_overlay',function(){
    $('html').removeClass('js-drawer-open lock-scroll');
    $('.bundle_images_zoom_popup').removeClass('active');
    $('.bundle_images_zoom_overlay').hide(); 
    $('.bundle_images_zoom_popup .zoom_image_container .bundle_popup_slider_container').html('');
  })
  
  $(document).on('click','.magnifier_popup_btn',function(){
    var ImagesHtml = $(this).find('.hidden_image').html();
    $('.bundle_images_zoom_popup .zoom_image_container .bundle_popup_slider_container').html(ImagesHtml);
    $('html').addClass('js-drawer-open lock-scroll');
    $('.bundle_images_zoom_popup').addClass('active');
    $('.bundle_images_zoom_overlay').show();
     var $flicketyCarousel = $('.bundle_popup_slider_container .bundle_popup_slider').flickity();
     $flicketyCarousel.flickity();
  })

  $(document).on('click', '.drawer--visible .drawer__underlay', function(){
    // $('.cart__drawer').removeClass('drawer--visible');
    // $('.cart__drawer').addClass('display-none');
    // $('body').css("overflow", "visible");
    $('.cart__drawer.drawer--visible .drawer__close').click();
  })

// Bundle code end
  $(document).on("click", ".cover_image .video-play", function () {
    $(this).parents(".cover-img-video").find("video").trigger("play");
    $(this).parents(".cover-img-video").find(".cover_image").hide();
    $(this).parents(".video").siblings().find(".cover-img-video video").trigger("pause");
    $(this).parents(".video").siblings().find(".cover-img-video .cover_image").show();
  });
  $(".video .video-sound").click(function (e) {
    var VideoSoundD = $(this).parents(".cover-img-video").find("video");
    if (VideoSoundD.prop("muted", true)) {
      VideoSoundD.prop("muted", false);
    } else VideoSoundD.prop("muted", false);
    {
      VideoSoundD.prop("muted", true);
    }
  });

  // upsell
  $(document).on('click', '.js-upsell-btn', function(){
    let  $thisUpsellVal = $(this).attr('data-value');
    $(this).parents('.upsell_option').find('.js-upsell-btn').removeClass('selected');
    $(this).addClass('selected');
    $(this).parents('.upsell_option').find('.cdk-select').val($thisUpsellVal).change();
 
  })
  $(document).on("change",".upsell_option select.cdk-select",function () {
      var FinalValue = "";
      $('.upsell__product__option .upsell_option').each(function () {
        var selectVal = $(this).find("select.cdk-select").val();
        // console.log('selectVal::'+selectVal);
        FinalValue += selectVal + " / ";
      });
      var newstr = FinalValue.substring(0, FinalValue.length - 3);
            console.log('newstr::'+newstr);
      var optionName_Selector = $('select.product_card-form__master-select option[check-data-sku="' +newstr +'"]');
      var optionName_val = optionName_Selector.val();
      // console.log('optionName_val::'+optionName_val);
      $('.product_card-form__master-select').val(optionName_val).change();
    });
  $(document).on("change",".product_card-form__master-select",function () {
      var thisMainVal = $(this).val(),
       ThisProdAvail = $(this).find('option[value="' + thisMainVal + '"]').attr("data-varaint-availability"),
       Upsell_price = $(this).find('option[value="' + thisMainVal + '"]').attr("data-price"),
       UpsellComparePrice = $(this).find('option[value="' + thisMainVal + '"]').attr("data-compare"),
       ThisProIMG = $(this).find('option[value="' + thisMainVal + '"]').attr("data-image"),
       metrial_value= $(this).find('option[value="' + thisMainVal + '"]').attr("metrial-value"),
      plating_value= $(this).find('option[value="' + thisMainVal + '"]').attr("plating-value");
      console.log("plating_value::" + plating_value);
      $('upsell-product').find(".new-price").text(Upsell_price);
      $('upsell-product').find(".old-price").text(UpsellComparePrice);
      $('upsell-product').find(".upsell__image__inner").attr('src',ThisProIMG);
      $('upsell-product').find("form input[name='id']").attr('value', thisMainVal); 
    if(metrial_value){
     $('upsell-product').find(".variant_material .material_value").text(metrial_value); 
      $('upsell-product').find(".variant_material").show();
    }
    else{
      $('upsell-product').find(".variant_material").hide();
    }
    if(plating_value){
     $('upsell-product').find(".variant_plating .plating_value").text(plating_value); 
      $('upsell-product').find(".variant_plating").show();
    }
    else{
      $('upsell-product').find(".variant_plating").hide();
    }
        if (ThisProdAvail == "true") {
          $('.cdk_custom_add').attr("data-btn","addToCart");
          $('.cdk_custom_add').find(".btn_text").text("Add To Cart");
         
        } else {
          $('.cdk_custom_add').find(".btn_text").text("Sold Out");
          $('.cdk_custom_add').attr("data-btn","soldout");
        }
    });
  let old_gift = $('.upsell .product__block__buttons .overlay_btn').attr('data-var');
   $(document).on('click', '.switch', function(e) {
    e.preventDefault();  // Prevent default behavior (e.g., form submission)

    let $upsell = $(this).parents('.upsell');
    let $overlayBtn = $upsell.find('.product__block__buttons .overlay_btn');
    let $checkbox = $(this).find('input');
    let gift_id = $checkbox.attr('data-var');
    let isChecked = $checkbox.prop('checked');
    $checkbox.prop('checked', !isChecked);

    // After the toggle, update the data-var of the overlay button
    if (isChecked) {
        // If the checkbox was checked and is now being unchecked, revert to old_gift
        console.log('Reverting to old gift ID');
        $overlayBtn.attr('data-var', old_gift); // Revert to the original gift ID
    } else {
        // If the checkbox was unchecked and is now being checked, update to the new gift_id
        console.log('Updating to new gift ID');
        $overlayBtn.attr('data-var', gift_id); // Set the new gift ID
    }
});
$(document).on('click', '.images-magnify', function(){
  $('.product-sticky-add-to-cart').addClass('upsell-visibile');
  $(this).parents('.upsell').find('.upsell-media').show();
  $('body').addClass('overflow__hidden');
})
$(document).on('click', '.upsell-media-close', function(){
  $('.product-sticky-add-to-cart').removeClass('upsell-visibile');
  $('.upsell-media').hide();
  $('body').removeClass('overflow__hidden');
})
$(document).ready(function() {
  var slickInitialized = false; // Track if the slider is initialized

  $('.images-magnify').on('click', function() {
    if (slickInitialized) {
      // If Slick is initialized, destroy it
      $('.media-upsell-wrapper').slick('unslick');
      slickInitialized = false; // Update the flag
    } else {
      // If Slick is not initialized, initialize it
      $('.media-upsell-wrapper').slick({
        autoplay: true,
        speed: 800,
        arrows: true,
        slidesToShow: 1,
        dots: true,
        prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none"><path d="M0.265172 7.59831L7.59868 0.265172C7.95225 -0.0883908 8.5258 -0.0883908 8.87936 0.265172L9.73478 1.12059C10.088 1.47378 10.0883 2.04582 9.73629 2.39976L3.92419 8.23865L9.73591 14.0779C10.0883 14.4319 10.0876 15.0039 9.7344 15.3571L8.87898 16.2125C8.52542 16.5661 7.95187 16.5661 7.59831 16.2125L0.265172 8.87898C-0.0883908 8.52542 -0.0883908 7.95187 0.265172 7.59831Z" fill="white"/></svg></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none"><path d="M9.73477 8.87942L2.40132 16.2128C2.04764 16.5665 1.47423 16.5665 1.12058 16.2128L0.265254 15.3575C-0.0878262 15.0044 -0.0885053 14.4322 0.263745 14.0783L6.07563 8.23903L0.263745 2.39982C-0.0885053 2.04591 -0.0878262 1.47367 0.265254 1.12059L1.12058 0.265263C1.47426 -0.0884211 2.04768 -0.0884211 2.40132 0.265263L9.73473 7.59867C10.0884 7.95232 10.0884 8.52573 9.73477 8.87942Z" fill="white"/></svg></button>',
      })
      slickInitialized = true; // Update the flag
    }
  });
});

$(document).on('click', '.size_chart_opener', function(){
  $('.size_chart').fadeIn();
  $('html,body').addClass('sizechart_overflow');
});

$(document).on('click', '.chart_header .close_chart', function(){
  $('.size_chart').fadeOut();
  $('html,body').removeClass('sizechart_overflow');
});

$(document).on('click', '.size_chart .chart_overlay', function(){
  $('.size_chart').fadeOut();
  $('html,body').removeClass('sizechart_overflow');
});

});
 
$('.swiper_cdk-slider').slick({
  autoplay: true,
  speed: 800,
  arrows: true,
  slidesToShow: 1,
  dots: true,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none"><path d="M0.265172 7.59831L7.59868 0.265172C7.95225 -0.0883908 8.5258 -0.0883908 8.87936 0.265172L9.73478 1.12059C10.088 1.47378 10.0883 2.04582 9.73629 2.39976L3.92419 8.23865L9.73591 14.0779C10.0883 14.4319 10.0876 15.0039 9.7344 15.3571L8.87898 16.2125C8.52542 16.5661 7.95187 16.5661 7.59831 16.2125L0.265172 8.87898C-0.0883908 8.52542 -0.0883908 7.95187 0.265172 7.59831Z" fill="white"/></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none"><path d="M9.73477 8.87942L2.40132 16.2128C2.04764 16.5665 1.47423 16.5665 1.12058 16.2128L0.265254 15.3575C-0.0878262 15.0044 -0.0885053 14.4322 0.263745 14.0783L6.07563 8.23903L0.263745 2.39982C-0.0885053 2.04591 -0.0878262 1.47367 0.265254 1.12059L1.12058 0.265263C1.47426 -0.0884211 2.04768 -0.0884211 2.40132 0.265263L9.73473 7.59867C10.0884 7.95232 10.0884 8.52573 9.73477 8.87942Z" fill="white"/></svg></button>',
})


$('.testimonials-slider').slick({
  autoplay: true,
  speed: 800,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: true,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none"><path d="M0.265172 7.59831L7.59868 0.265172C7.95225 -0.0883908 8.5258 -0.0883908 8.87936 0.265172L9.73478 1.12059C10.088 1.47378 10.0883 2.04582 9.73629 2.39976L3.92419 8.23865L9.73591 14.0779C10.0883 14.4319 10.0876 15.0039 9.7344 15.3571L8.87898 16.2125C8.52542 16.5661 7.95187 16.5661 7.59831 16.2125L0.265172 8.87898C-0.0883908 8.52542 -0.0883908 7.95187 0.265172 7.59831Z" fill="white"/></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none"><path d="M9.73477 8.87942L2.40132 16.2128C2.04764 16.5665 1.47423 16.5665 1.12058 16.2128L0.265254 15.3575C-0.0878262 15.0044 -0.0885053 14.4322 0.263745 14.0783L6.07563 8.23903L0.263745 2.39982C-0.0885053 2.04591 -0.0878262 1.47367 0.265254 1.12059L1.12058 0.265263C1.47426 -0.0884211 2.04768 -0.0884211 2.40132 0.265263L9.73473 7.59867C10.0884 7.95232 10.0884 8.52573 9.73477 8.87942Z" fill="white"/></svg></button>',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1008,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 800,
      settings: 'unslick',
    },
  ],
 
})
  